import { render } from "./serviceComponent.vue?vue&type=template&id=495424d4&scoped=true"
import script from "./serviceComponent.vue?vue&type=script&lang=js"
export * from "./serviceComponent.vue?vue&type=script&lang=js"

import "./serviceComponent.vue?vue&type=style&index=0&id=495424d4&scoped=true&lang=css"

import exportComponent from "F:\\work\\rahul\\mangal karyala\\gore-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495424d4"]])

export default __exports__